import { StateStatus } from "types/stateStatus";

export function getLeadStatusClass(status: StateStatus): string {
    switch (status) {
        case StateStatus.Open:
            return "text-italic open bolder";
        case StateStatus.Acquired:
            return "text-italic acquired bolder";
        case StateStatus.Rejected:
            return "text-italic rejected bolder";
        case StateStatus.Pending:
            return "text-italic pending bolder";
        case StateStatus.Closed:
            return "text-italic closed bolder";
        default:
            return "text-italic bolder shiny-text";
    }
}
